import { fetchAPI } from '../helpers';
import AppContext from '../AppContext';

class AnalyticsService {
    static getPlatformReport = (referenceDate) => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token,
            url: `${config.AnalyticsService}report/${platformId}${referenceDate ? `/${referenceDate}` : ''}`,
            method: 'GET',
        });
    };

    static getSuggested = () => {
        let appContext = new AppContext();
        let token = appContext.getToken();
        let config = appContext.getConfig();
        let platformId = appContext.getPlatformId();

        return fetchAPI({
            token,
            url: `${config.AnalyticsService}suggested/${platformId}`,
            method: 'GET',
        });
    };
}
export default AnalyticsService;
